module.exports = __webpack_public_path__ + "img/8-Secret.51d234f.png";